module.exports = __webpack_public_path__ + "img/premium-section-background3.3f49962.jpg";